export default "__VITE_ASSET__7ea77770__"